import React from 'react';
import './Contact.css';

import emailjs from 'emailjs-com';

// import{ init } from 'emailjs-com';
// init("user_OeWYEOvxV4MqBUwijCz2F");

const Contact = () => {


    function sendEmail(e) {
        e.preventDefault();
    
        emailjs.sendForm('service_yumjw4k', 'template_xxegr3p', e.target, 'user_OeWYEOvxV4MqBUwijCz2F')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
        console.log('hello')

        e.target.reset();
    }

    return (
        <section id="contact">
            <div className="contact_info">
                <h1>Contact</h1>
                <p>Have a question or want to work together?</p>
            </div>
            <div className="contact_container">
                <form onSubmit={sendEmail}>
                    <input type="text" name="name" placeholder="Enter name" required/>

                    <input  type="email" name="email" placeholder="Enter email" required/>

                    <textarea rows="5" cols="50" name="message" placeholder="Your Message" required/>

                    <button type="submit" value="Send">Let's Talk!!</button>
                </form>
            </div>
        </section>
    )
}

export default Contact;
